export interface PaymentPreviewPayableV1Response {
  burn: string;
  amount: number;
  surcharge?: number;
  additionalFee?: number;
  serviceFee?: number;
  disputeTotal?: number;
  description?: string;
  isDiscountApplied: boolean;
  appliedDiscount: number;
  availableDiscount: number;
  discountExpirationDate: Date;
  discountExclusionReasons: string[];
  /*  DiscountExpired, #Discount is no longer applicable
      ScheduledPaymentDateIsAfterDiscountExpiration, #Payment Scheduled too late
      SupplierUserOverride #Supplier user has overridden discount
      NotPaidInFull, #Full amount of bill is not being paid
      PaymentMethodNotDiscountable, #Cards not allowed discount
      NotEnoughDiscountInfo #Not enough discount info in db
  */
  flexibleTemplates?: FlexibleTemplatesResponseDto;
  timedCardAcceptance?: TimedCardAcceptanceResponseDto;
  hasPastPayments?: PayablePaymentStatus;
}

export class FlexibleTemplatesResponseDto {
  isApplicable: boolean;
  availableRules: FlexiblePaymentTemplateRestrictionCode[];
  rejectedReasons: FlexiblePaymentTemplateRejectedReasonCode[];
  isRejected: boolean;
}

export type FlexiblePaymentTemplateRestrictionCode =
  | 'ALLOW_CARD_PAYMENTS'
  | 'ALLOW_BANK_PAYMENTS'
  | 'ALLOW_SURCHARGING';

export type FlexiblePaymentTemplateRejectedReasonCode =
  | 'NONE'
  | 'CARD_PAYMENTS_NOT_ALLOWED'
  | 'BANK_PAYMENTS_NOT_ALLOWED'
  | 'SURCHARGING_NOT_ALLOWED';

export class TimedCardAcceptanceResponseDto {
  isApplicable: boolean;
  isGracePeriodExpired: boolean;
  rejectedReason?: 'DocumentDate' | 'DueDate';
  isRejected: boolean;
}

export enum PayablePaymentStatus {
  Unclassified = 'Unclassified',
  FullyPaid = 'FullyPaid',
  PartiallyPaid = 'PartiallyPaid',
  FullyConsumed = 'FullyConsumed',
  HasPastPayment = 'HasPastPayment',
}
